import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import InputMask from "react-input-mask";
import { Save } from "lucide-react";
import { cadastrarUsuario, editarUsuario, listarPerfisRevenda, listarRevendasDistribuidor, obterUsuarioPorId } from "../services/api";
import PermissoesUsuario, { flagsPadrao } from "./PermissoesUsuario";

const campo = "w-full px-3 py-2.5 rounded-xl border outline-none dark:bg-slate-950/40 dark:border-white/10 dark:text-white";

const FormUsuarioRevendaDistribuidor = ({ token }) => {
  const { id } = useParams();
  const isEdit = Boolean(id);
  const [searchParams] = useSearchParams();
  const revendaQuery = searchParams.get("revendaId") || "";
  const navigate = useNavigate();
  const [revendas, setRevendas] = useState([]);
  const [perfis, setPerfis] = useState([]);
  const [permissoes, setPermissoes] = useState(flagsPadrao("revenda"));
  const [usuario, setUsuario] = useState({
    revendaId: revendaQuery ? Number(revendaQuery) : 0,
    nome: "",
    telefone: "",
    email: "",
    senha: "",
    ativo: true,
    perfilId: 1,
  });

  useEffect(() => {
    listarRevendasDistribuidor(token)
      .then((res) => setRevendas(Array.isArray(res.data) ? res.data : []))
      .catch(() => setRevendas([]));
    listarPerfisRevenda(token)
      .then((res) => setPerfis(Array.isArray(res.data) ? res.data : []))
      .catch(() => setPerfis([]));
  }, [token]);

  useEffect(() => {
    if (!isEdit) return;
    obterUsuarioPorId(id, token)
      .then((res) => {
        const d = res.data || {};
        setUsuario({
          revendaId: d.revendaId || 0,
          nome: d.nome || "",
          telefone: d.telefone || "",
          email: d.email || "",
          senha: "",
          ativo: d.ativo !== false,
          perfilId: d.perfilId || 1,
        });
        const salvas = d.permissoes || d.Permissoes;
        setPermissoes(Array.isArray(salvas) && salvas.length ? salvas : flagsPadrao("revenda"));
      })
      .catch((e) => console.error(e));
  }, [id, isEdit, token]);

  const set = (e) => {
    const { name, value, type, checked } = e.target;
    setUsuario((prev) => ({
      ...prev,
      [name]: name === "revendaId" || name === "perfilId" ? Number(value) : type === "checkbox" ? checked : value,
    }));
  };

  const salvar = async (e) => {
    e.preventDefault();
    if (!usuario.revendaId) {
      alert("Selecione a revenda.");
      return;
    }
    if (!isEdit && !usuario.senha) {
      alert("Senha é obrigatória.");
      return;
    }
    const payload = {
      RevendaId: Number(usuario.revendaId),
      Nome: usuario.nome,
      Telefone: usuario.telefone,
      Email: usuario.email,
      Ativo: Boolean(usuario.ativo),
      Senha: usuario.senha,
      PerfilId: Number(usuario.perfilId) || 1,
      Permissoes: permissoes,
    };
    try {
      if (isEdit) await editarUsuario(id, payload, token);
      else await cadastrarUsuario(payload, token);
      navigate(`/revendas/usuarios${revendaQuery ? `?revendaId=${revendaQuery}` : ""}`);
    } catch (err) {
      const data = err?.response?.data;
      alert(typeof data === "string" ? data : data?.message || "Erro ao salvar o usuário.");
    }
  };

  return (
    <div className="max-w-3xl mx-auto">
      <form onSubmit={salvar} className="zen-card rounded-2xl p-6 shadow-sm space-y-4 dark:backdrop-blur">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white">{isEdit ? "Editar usuário da revenda" : "Novo usuário da revenda"}</h2>
        <label className="flex items-center gap-2 text-sm">
          <input type="checkbox" name="ativo" checked={!!usuario.ativo} onChange={set} /> Usuário ativo
        </label>
        <div>
          <label className="block text-sm mb-1">Revenda</label>
          <select name="revendaId" value={usuario.revendaId || ""} onChange={set} className={campo} required>
            <option value="">Selecione</option>
            {revendas.map((r) => (
              <option key={r.id} value={r.id}>{r.nomeFantasia || r.razaoSocial}</option>
            ))}
          </select>
        </div>
        <input className={campo} name="nome" placeholder="Nome" value={usuario.nome} onChange={set} required />
        <InputMask mask="(99) 99999-9999" className={campo} name="telefone" placeholder="Telefone" value={usuario.telefone} onChange={set} />
        <input className={campo} type="email" name="email" placeholder="E-mail" value={usuario.email} onChange={set} required />
        <select name="perfilId" value={usuario.perfilId} onChange={set} className={campo}>
          {perfis.map((p) => <option key={p.id} value={p.id}>{p.nome}</option>)}
        </select>
        <input className={campo} type="password" name="senha" placeholder={isEdit ? "Nova senha (em branco mantém)" : "Senha"} value={usuario.senha} onChange={set} required={!isEdit} />
        <PermissoesUsuario audiencia="revenda" value={permissoes} onChange={setPermissoes} />
        <div className="flex justify-end">
          <button type="submit" className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-blue-600 text-white font-semibold text-sm">
            <Save size={18} /> Salvar
          </button>
        </div>
      </form>
    </div>
  );
};

export default FormUsuarioRevendaDistribuidor;
